import { render, staticRenderFns } from "./listPannel.vue?vue&type=template&id=4d8d2348"
import script from "./listPannel.vue?vue&type=script&lang=js"
export * from "./listPannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports